import { TableSelectionEvent } from "@mcleod/components";
import { MapSettings } from "@mcleod/core";
import { AutogenLayoutZoneRegionList } from "./autogen/AutogenLayoutZoneRegionList";
import { MapZoneSelectionUtil } from "./MapZoneSelectionUtil";
import { ZoneMapScreen } from "./MapZoneUtil";

export class ZoneRegionList extends AutogenLayoutZoneRegionList {

    private mapVendor = MapSettings.getSingleton().getZoneMapVendor();
    private mapSelector: MapZoneSelectionUtil;

    override onLoad() {
        this.mainDataSource.search();
        this.mapSelector = new MapZoneSelectionUtil(this.mapVendor, this.mapRoute);
    }

    async tableZoneRegionListOnSelect(event: TableSelectionEvent) {
        await this.mapSelector.handleRowSelection(ZoneMapScreen.ZoneRegion, this.tableZoneRegionList.selectedRow);
    }

}
